// src/components/ModalAgregarRol.jsx
import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarRol = ({ show, onClose, onRolAgregado }) => {
    const [nuevoRol, setNuevoRol] = useState({ nombre_rol: "", descripcion: "" });

    const handleAgregarRol = async (e) => {
        e.preventDefault();
        if (!nuevoRol.nombre_rol || !nuevoRol.descripcion) {
            alert("Todos los campos son requeridos.");
            return;
        }

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "roles",
                nombre_rol: nuevoRol.nombre_rol,
                descripcion: nuevoRol.descripcion
            });

            onRolAgregado(); // Actualizar lista de roles
            onClose(); // Cerrar modal
            setNuevoRol({ nombre_rol: "", descripcion: "" }); // Limpiar formulario
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Rol</h2>
                <form onSubmit={handleAgregarRol}>
                    <input
                        type="text"
                        value={nuevoRol.nombre_rol}
                        onChange={(e) => setNuevoRol({ ...nuevoRol, nombre_rol: e.target.value })}
                        placeholder="Nombre del Rol"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={30}
                    />
                    <textarea
                        value={nuevoRol.descripcion}
                        onChange={(e) => setNuevoRol({ ...nuevoRol, descripcion: e.target.value })}
                        placeholder="Descripción"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarRol;
